import React from 'react';
import styles from './UserMenu.module.css';
import { getInitials } from './userIdentity';

export type UserIdentityHeaderProps = {
  displayName: string;
  email: string;
};

export function UserIdentityHeader({ displayName, email }: UserIdentityHeaderProps) {
  const initials = getInitials(displayName, email);
  const ariaLabel =
    displayName && email
      ? `Signed in as ${displayName}, ${email}`
      : displayName
        ? `Signed in as ${displayName}`
        : email
          ? `Signed in as ${email}`
          : 'Signed in user';

  return (
    <div className={styles.userHeader} role="group" aria-label={ariaLabel}>
      <div className={styles.userHeaderAvatar} aria-hidden="true">
        {initials}
      </div>
      <div className={styles.userHeaderText}>
        {displayName ? (
          <span className={styles.userHeaderName} title={displayName}>
            {displayName}
          </span>
        ) : null}
        {email ? (
          <span className={styles.userHeaderEmail} title={email}>
            {email}
          </span>
        ) : null}
      </div>
    </div>
  );
}
